var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 50,
    viewBox: "0 0 98 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3823_44163)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 50,
    rx: 3,
    fill: "#F6F8FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0482 33.6492H40.2461L43.2497 16.4062H48.0515L45.0482 33.6492Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4557 16.8279C61.5086 16.479 60.0063 16.0938 58.1486 16.0938C53.4064 16.0938 50.067 18.4416 50.0465 21.7983C50.0071 24.2749 52.4374 25.6505 54.2551 26.4762C56.113 27.3201 56.7445 27.8708 56.7445 28.623C56.7256 29.7781 55.2433 30.3106 53.8607 30.3106C51.9435 30.3106 50.9162 30.0361 49.3551 29.3934L48.7228 29.1179L48.0508 32.9886C49.1771 33.465 51.2521 33.8877 53.4064 33.9062C58.4451 33.9062 61.7255 31.5947 61.7643 28.0176C61.7835 26.0547 60.5002 24.5507 57.7335 23.3216C56.0539 22.5327 55.0253 22.0007 55.0253 21.1934C55.045 20.4596 55.8953 19.7079 57.7913 19.7079C59.3524 19.6711 60.4994 20.0195 61.3683 20.3682L61.8027 20.5513L62.4557 16.8279Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8359 27.5406C69.2313 26.5501 70.7531 22.7162 70.7531 22.7162C70.7331 22.753 71.1478 21.7073 71.3849 21.0654L71.7205 22.5511C71.7205 22.5511 72.6299 26.6785 72.8273 27.5406C72.0768 27.5406 69.7844 27.5406 68.8359 27.5406ZM74.7635 16.4062H71.049C69.9036 16.4062 69.0334 16.7178 68.5391 17.8369L61.4062 33.649H66.4449C66.4449 33.649 67.2745 31.5208 67.4528 31.0624C68.0056 31.0624 72.9072 31.0624 73.6183 31.0624C73.7561 31.6678 74.1913 33.649 74.1913 33.649H78.6375L74.7635 16.4062Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2349 16.4062L31.532 28.1643L31.0181 25.7796C30.1487 23.028 27.4219 20.0385 24.3789 18.552L28.6865 33.6309H33.7646L41.3127 16.4062H36.2349Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1645 16.4062H19.4384L19.3594 16.7546C25.3862 18.1855 29.3777 21.6347 31.0176 25.7804L29.338 17.8557C29.0615 16.7544 28.2117 16.4426 27.1645 16.4062Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3823_44163"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.svg";
export { ForwardRef as ReactComponent };